<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-switch :theme="$otTheme" size="mini" v-model="switchValue" active-color="#13ce66" inactive-color="#ff4949">
            </ot-switch>
            <ot-switch :theme="$otTheme" size="small" v-model="switchValue" active-color="#13ce66" inactive-color="#ff4949">
                <span slot="inactive">#ff4949</span>
                <span slot="active">#13ce66</span>
            </ot-switch>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            switchValue: false,
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-switch%20size%3D%22mini%22%20v-model%3D%22switchValue%22%20active-color%3D%22%2313ce66%22%20inactive-color%3D%22%23ff4949%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-switch%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-switch%20size%3D%22small%22%20v-model%3D%22switchValue%22%20active-color%3D%22%2313ce66%22%20inactive-color%3D%22%23ff4949%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%20slot%3D%22inactive%22%3E%23ff4949%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%20slot%3D%22active%22%3E%2313ce66%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-switch%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20switchValue%3A%20false%2C%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
};
</script>
